import React from "react";
import playStoreLogo from "../assets/google_play.png";   // your logo
import appStoreLogo from "../assets/app_store_logo.png";     // your logo

const AppDownloadSection = () => {
  return (
    <section
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8f9fa",
        padding: "40px 20px",
        textAlign: "center",
      }}
    >
      <h2 style={{ marginBottom: "20px", fontSize: "1.8rem" }}>
        Download the Speak Bold with KK App
      </h2>
      <p style={{ marginBottom: "30px", fontSize: "1rem", color: "#555" }}>
        Learn, practice and master your communication skills anytime, anywhere.
      </p>

      <div style={{ display: "flex", gap: "20px" }}>
        <a
          href="https://play.google.com/store/apps/details?id=com.kktech.kmdialogues&pcampaignid=web_share"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={playStoreLogo}
            alt="Get it on Google Play"
            style={{ height: "60px" }}
          />
        </a>
      </div>
    </section>
  );
};

export default AppDownloadSection;
